const Button = ({ text, small, textColor, width, textSize, onClick, bg, disabledBg, border, children, disabled, rounded, smallText, type, noHover }) => {
  const handleClick = () => {
    if (!disabled) {
      onClick && onClick();
    }
  };

  return (
    <button className={`flex ${width && 'w-full'}`} type={type} disabled={disabled}>
      {/* <div className={`px-3 py-2 bg-${color} border border-${color} rounded text-white font-medium hover:opacity-90 cursor-pointer w-max`} onClick={onClick}> */}
      <div
        className={`${small ? 'px-2 py-1' : 'px-3 py-3'} justify-center border ${textColor} font-medium ${width ? width : 'w-max'} flex ${
          rounded ? 'rounded-full' : 'rounded'
        } ${disabled ? `${disabledBg ? disabledBg : 'bg-gray-300'} cursor-not-allowed` : `${border} ${bg}`} ${
          noHover ? 'hover:opacity-100 cursor-default' : 'hover:opacity-75 cursor-pointer'
        }`}
        onClick={handleClick}>
        <div className="flex flex-col px-3 text-center">
          <p className={`uppercase ${textSize}`}>{text}</p>
          <p className="text-xs">{smallText}</p>
        </div>
        {children && <div className="flex items-center">{children}</div>}
      </div>
    </button>
  );
};

Button.defaultProps = {
  text: 'Button Text',
  textColor: 'text-white',
  bg: 'bg-blue',
  border: 'border-blue',
  type: 'button'
};

export default Button;
